/**
 * Auth v2 feature-flag helper.
 *
 * Controls whether the web portal talks to the v2 auth endpoints (`/v2/auth/login`,
 * `/v2/auth/switch-profile`, etc.) and shows the v2 UI (no persona picker, profile
 * switcher, etc.). Default is **off** — the portal falls back to v1 behavior,
 * which is itself backward-compatible since AB#1432 relaxed the legacy login.
 *
 * Flip to `true` in `.env.local` / `.env.development` for dogfood, then via the
 * Azure Static Web Apps env var for staged prod rollout (PRD §7 phase 3 → 4 → 5).
 *
 * Environment variable: `REACT_APP_AUTH_V2_ENABLED` (string "true" to enable).
 */
export const isAuthV2Enabled = (): boolean =>
    (process.env.REACT_APP_AUTH_V2_ENABLED ?? '').toLowerCase() === 'true';
